import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import Button from 'components/buttons/Button'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class ForgotPasswordForm extends React.Component {
  
  static propTypes = {
    form     : PropTypes.string.isRequired,
    onSubmit : PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form onSubmit={handleSubmit}>
        <h1>Forgot Password</h1>
        <br/>
        <Field 
          name='email' 
          label='Email'
          type='email'
          component={TextField} 
          />
        <div className={styles.Hint}>
          A password reset link will be sent to your email address.
        </div>
        <Button 
          loading={this.props.submitting}
          type='submit'
          color='orange' 
          style={{margin: '2rem 0rem'}}>
          Send Reset Link
        </Button>
        <div style={{textAlign:'center', padding: '1rem 0'}}>
          <NavLink 
            style={{  
              fontFamily: 'Roboto',
              fontSize: '1.6rem',
              lineHeight: '1.5',
              color: '#f24f12',
            }}
            to='/login'>
            I remembered my password
          </NavLink>
        </div>
      </Form>
    )
  }

}



// WEBPACK FOOTER //
// ./src/forms/ForgotPasswordForm/index.jsx